import React, { useContext, useEffect } from 'react';
import type { Dispatch, FC, SetStateAction } from 'react';

import { MenuGroup } from '@atlaskit/menu';
import { Stack } from '@atlaskit/primitives';

import type { ManualRule } from '@atlassian/automation-manual-triggers';

import {
	ExperienceTrackerContext,
	AUTOMATION_MANUAL_TRIGGERS,
} from '@confluence/experience-tracker';

import { useAutomationMenu } from '../common/ConfluenceManualRulesContainer';

import { AutomationModalEmptyState } from './AutomationModalEmptyState';
import { AutomationModalRule } from './AutomationModalRule';

type AutomationModalRuleListProps = {
	selectedRuleId: number | undefined;
	setSelectedRuleId: Dispatch<SetStateAction<number | undefined>>;
};

export const AutomationModalRuleList: FC<AutomationModalRuleListProps> = ({
	selectedRuleId,
	setSelectedRuleId,
}) => {
	const { rules, analyticsSource } = useAutomationMenu();
	const experienceTracker = useContext(ExperienceTrackerContext);

	useEffect(() => {
		experienceTracker.succeed({
			name: AUTOMATION_MANUAL_TRIGGERS,
			attributes: {
				source: analyticsSource,
				ruleCount: rules.length,
			},
		});
	}, [experienceTracker, analyticsSource, rules.length]);

	if (rules.length === 0) {
		return <AutomationModalEmptyState />;
	}

	return (
		<MenuGroup>
			<Stack space="space.050">
				{rules.map((rule: ManualRule) => (
					<AutomationModalRule
						key={`manual-rule-${rule.id}`}
						rule={rule}
						selectedRuleId={selectedRuleId}
						setSelectedRuleId={setSelectedRuleId}
					/>
				))}
			</Stack>
		</MenuGroup>
	);
};
